import { ApplicationTypeEnum, ApproveStatusEnum } from "@/types/reimburse";

export type ApproveStatusInfo = {
  label: string;
  color: string;
};

export type ApplicationTypeInfo = {
  label: string;
  color: string;
};

export const applicationTypeMap: Record<
  ApplicationTypeEnum,
  ApplicationTypeInfo
> = {
  [ApplicationTypeEnum.REIMBURSEMENT]: {
    label: "reimburse.reimbursement",
    color: "blue",
  },
  [ApplicationTypeEnum.DAILY_SUPPLIES]: {
    label: "reimburse.dailySupplies",
    color: "orange",
  },
  [ApplicationTypeEnum.MATERIAL_OVER_ISSUE]: {
    label: "reimburse.materialOverIssue",
    color: "red",
  },
};

export const approveStatusMap: Record<ApproveStatusEnum, ApproveStatusInfo> = {
  [ApproveStatusEnum.DRAFT]: {
    label: "reimburse.statusDraft",
    color: "default",
  },
  [ApproveStatusEnum.PENDING]: {
    label: "reimburse.statusPending",
    color: "processing",
  },
  [ApproveStatusEnum.APPROVED]: {
    label: "reimburse.statusApproved",
    color: "success",
  },
  [ApproveStatusEnum.REJECTED]: {
    label: "reimburse.statusRejected",
    color: "error",
  },
  [ApproveStatusEnum.RETURNED]: {
    label: "reimburse.statusReturned",
    color: "warning",
  },
};

export const getApplicationTypeInfo = (type: ApplicationTypeEnum) =>
  applicationTypeMap[type];

export const getApproveStatusInfo = (status: ApproveStatusEnum) =>
  approveStatusMap[status];
